export enum ChartType {
    ColumnChart = 'COLUMN_CHART',
    LineChart = 'LINE_CHART',
    SplineChart = 'SPLINE_CHART',
    StackedColumnChart = 'STACKED_COLUMN_CHART',
    VariwideChart = 'VARIWIDE_CHART',
    Stock = 'STOCK',
    Dashboard = 'DASHBOARD',
}
